import { Text } from "flicket-ui";
import { useRouter } from "next/router";
import { useWillShowPreviewCompetition } from "~features/events/hooks/usePreviewCompetition";

import { EventAccessStatus } from "~graphql/sdk";
import { useAccount } from "~hooks";
import { useEventAccessControl } from "~hooks/useEventAccessControl";

const BANNER_HEIGHT = "36px";

export default function HeaderAlertBanner() {
  const {
    isBannerVisible,
    showAdminPreviewBanner,
    showBackOfficeOrderBanner,
  } = useShowHeaderBanner();

  if (!isBannerVisible) {
    return null;
  }

  const label = (() => {
    if (showAdminPreviewBanner) {
      return "Event preview";
    }

    if (showBackOfficeOrderBanner) {
      return "Back office order";
    }

    return "";
  })();

  return (
    <Text
      color="N100"
      variant="demiBold.L"
      textAlign="center"
      backgroundColor="N700"
      py={"3/4"}
      h={BANNER_HEIGHT as any}
    >
      {label}
    </Text>
  );
}

export function useShowHeaderBanner() {
  const { pathname } = useRouter();
  const { accessType, isLoading } = useEventAccessControl();
  const { isAdmin, hasLoaded } = useAccount();
  const showPreviewCompetition = useWillShowPreviewCompetition();

  const showAdminPreviewBanner =
    !isLoading &&
    (accessType === EventAccessStatus.AllowedAdminPreview ||
      showPreviewCompetition);

  const showBackOfficeOrderBanner =
    hasLoaded &&
    isAdmin &&
    (pathname.includes("/reservation") ||
      pathname.includes("/orders") ||
      pathname.includes("/checkout/"));

  return {
    showAdminPreviewBanner,
    showBackOfficeOrderBanner,
    isBannerVisible: showAdminPreviewBanner || showBackOfficeOrderBanner,
    bannerHeight: BANNER_HEIGHT,
  };
}
